import { render, staticRenderFns } from "./blogGrid3.vue?vue&type=template&id=3617de2b&"
import script from "./blogGrid3.vue?vue&type=script&lang=js&"
export * from "./blogGrid3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports